import { ChevronRight, ChevronsRight } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ChevronRightIcon = DeckardIconWrapper({
  Icon: ChevronRight,
  DoubleIcon: ChevronsRight,
});
